"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var MinusCircleOutline = function MinusCircleOutline(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/minus_circle-minus-circle" + unique,
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "combined-shape-minus-circle" + unique,
    transform: "translate(-1255.000000, -544.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "combined-shape-minus-circle-2" + unique,
    transform: "translate(130.000000, 433.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "glyphs/nav/minus-Expanded" + unique,
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "glyphs/nav/minus-Expanded/Icons/16px/Collapse/Gray" + unique,
    transform: "translate(1125.000000, 40.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.00285,1.50015 C6.21135,1.50015 1.49985,6.21165 1.49985,12.00015 C1.49985,17.79015 6.21135,22.49865 12.00285,22.49865 C17.79135,22.49865 22.49985,17.79015 22.49985,12.00015 C22.49985,6.21165 17.79135,1.50015 12.00285,1.50015 M12.0032786,0.00015 C5.38436236,0.00015 -0.000257150511,5.38476951 -0.000257150511,12.0002572 C-0.000257150511,18.6174591 5.38436236,23.99865 12.0032786,23.99865 C18.6187662,23.99865 23.9999572,18.6174591 23.9999572,12.0002572 C23.9999572,5.38476951 18.6187662,0.00015 12.0032786,0.00015 M17.25585,13.42605 L6.73785,13.42605 C5.95335,13.42605 5.31435,12.78705 5.31435,12.00255 C5.31435,11.21355 5.95335,10.57305 6.73785,10.57305 L17.25585,10.57305 C18.04335,10.57305 18.68235,11.21205 18.68235,11.99805 C18.68235,12.78555 18.04335,13.42605 17.25585,13.42605",
    id: "path-1-minus-circle-outline" + unique
  })))))));
};

MinusCircleOutline.propTypes = propTypes;
var _default = MinusCircleOutline;
exports["default"] = _default;